export const PageDataState = {
    Searchs: {
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษา',
            value: '',
            placeholder: 'สถานศึกษา',
        },        
        official_course_code: {
            type: 'text',
            id: 'official_course_code',
            label: 'รหัสหลักสูตร',
            value: '',
            placeholder: 'รหัสหลักสูตร',
        },         
        course_eb_01_name: {
            type: 'text',
            id: 'course_eb_01_name',
            label: 'หลักสูตร',
            value: '',
            placeholder: 'หลักสูตร',
        },
        course_checked: {
            type: 'checkbox',
            group: 'eec-hdc',
            id: 'course_checked',
            label: 'ตรวจสอบหลักสูตรแล้ว',
            value: '',
            placeholder: 'ตรวจสอบหลักสูตรแล้ว',
        }, 
        budget_within_criteria: {
            type: 'checkbox',
            group: 'eec_hdc',
            id: 'budget_within_criteria',
            label: 'งบประมาณเป็นไปตามเกณฑ์',
            value: '',
            placeholder: 'งบประมาณเป็นไปตามเกณฑ์',
        },          
        hdc_status: {
            type: 'select',
            id: 'hdc_status',
            label: 'สกพอ.',
            value: '',
            placeholder: 'สกพอ.',
        },
        authorized_status: {
            type: 'select',
            id: 'authorized_status',
            label: 'ผู้มีอำนาจ',
            value: '',
            placeholder: 'ผู้มีอำนาจ',
        },  
        course_status: {
            type: 'select',
            id: 'course_status',
            label: 'การอบรม',
            value: '',
            placeholder: 'การอบรม',
        },                          
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        course_eb_01_id: {
            type: 'select',
            id: 'course_eb_01_id',
            label: 'รหัสหลักสูตร (ตามประกาศ สกพอ.)',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        course_eb_01_name: {
            type: 'select',
            id: 'course_eb_01_name',
            label: 'ชื่อหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        /**         
        reference_name: {
            type: 'text',
            id: 'reference_name',
            label: 'ชื่อหลักสูตร',
            value: '',
            placeholder: 'ชื่อหลักสูตร',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        */
        academy_id: {
            type: 'select',
            id: 'academy_id',
            label: 'สถานศึกษาผู้รับผิดชอบหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        course_responser: {
            type: 'text',
            id: 'course_responser',
            label: 'ชื่อผู้รับผิดชอบหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 255
            },
            error: { status: null, msg: '' }
        },
        course_responser_contact: {
            type: 'text',
            id: 'course_responser_contact',
            label: 'โทรศัพท์',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 10,
                maxLength: 255
            },
            error: { status: null, msg: '' }
        },                
        /** 
        academy_user_id: {
            type: 'select',
            id: 'academy_user_id',
            label: 'ผู้รับผิดชอบหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },   
        */
        registration_fee: {
            type: 'text',
            id: 'registration_fee',
            label: 'อัตราค่าลงทะเบียนตลอดหลักสูตร',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 100000
            },
            error: { status: null, msg: '' }
        },  
        total_budget: {
            type: 'text',
            id: 'total_budget',
            label: 'งบประมาณ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 100,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },          
        budget_request_to_hdc: {
            type: 'text',
            id: 'budget_request_to_hdc',
            label: 'วงเงินที่ขอรับการสนับสนุน',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },  
        budget_support_by_hdc: {
            type: 'text',
            id: 'budget_support_by_hdc',
            label: 'คิดเป็นวงเงินค่าใช้จ่ายต่อคน',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 1000000
            },
            error: { status: null, msg: '' }
        },  
        academy_signer_name: {
            type: 'text',
            id: 'academy_signer_name',
            label: 'ผู้บริหารสถานศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        }, 
        academy_signer_position: {
            type: 'text',
            id: 'academy_signer_position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        academy_sign_date: {
            type: 'text',
            id: 'academy_sign_date',
            label: 'วันที่ลงนาม',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },    
        academy_sign_file: {
            type: 'file',
            id: 'academy_sign_file',
            label: 'เอกสาร ลายมือชื่อ / ตราประทับ (ถ้ามี)',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            },
            error: { status: null, msg: '' }
        },                                       
        course_checked: {
            type: 'checkbox',
            id: 'course_checked',
            label: 'ตรวจสอบหลักสูตรแล้ว',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },  
        budget_within_criteria: {
            type: 'checkbox',
            id: 'budget_within_criteria',
            label: 'งบประมาณเป็นไปตามเกณฑ์',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },   
        hdc_status: {
            type: 'select',
            id: 'hdc_status',
            label: '',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        }, 
        hdc_reject_cause: {
            type: 'textarea',
            rows: 5,
            id: 'hdc_reject_cause',
            label: 'ไม่สมควรอนุมัติเนื่องจาก',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },   
        office_signer_name: {
            type: 'text',
            id: 'office_signer_name',
            label: 'เจ้าหน้าที่',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },  
        office_sign_date: {
            type: 'text',
            id: 'office_sign_date',
            label: 'วันที่',
            value: '',
            validator: {
                type: 'date',
                required: false,
            },
            error: { status: null, msg: '' }
        },     
        office_sign_file: {
            type: 'file',
            id: 'office_sign_file',
            label: 'เอกสาร ลายมือชื่อ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            },
            error: { status: null, msg: '' }
        },                        
        authorized_status: {
            type: 'select',
            id: 'authorized_status',
            label: 'คำสั่งการของผู้มีอำนาจอนุมัติ',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },                         
        authorizer_name: {
            type: 'text',
            id: 'authorizer_name',
            label: 'ผู้มีอำนาจ',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        }, 
        authorized_date: {
            type: 'text',
            id: 'authorized_date',
            label: 'วันที่',
            value: '',
            validator: {
                type: 'date',
                required: false,
            },
            error: { status: null, msg: '' }
        },   
        authorizer_sign_file: {
            type: 'file',
            id: 'authorizer_sign_file',
            label: 'เอกสาร ลายมือชื่อ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            },
            error: { status: null, msg: '' }
        },          
        budget_code: {
            type: 'text',
            id: 'budget_code',
            label: 'เลขที่กันเงินงบประมาณ',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },                         
        operator_name: {
            type: 'text',
            id: 'operator_name',
            label: 'เจ้าหน้าที่',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        }, 
        finance_date: {
            type: 'text',
            id: 'finance_date',
            label: 'วันที่',
            value: '',
            validator: {
                type: 'date',
                required: false,
            },
            error: { status: null, msg: '' }
        },    
        operator_sign_file: {
            type: 'file',
            id: 'operator_sign_file',
            label: 'เอกสาร ลายมือชื่อ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            },
            error: { status: null, msg: '' }
        },                
        enroll_key: {
            type: 'text',
            id: 'enroll_key',
            label: 'ENROLL KEY',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        }, 
        course_status: {
            type: 'select',
            id: 'course_status',
            label: 'สถานะการจัดอบรม',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },         
    },
    InputGroup: {
        Checkbox: {
            search_eec_hdc: {
                display: 'inline',
                label: 'EEC-HDC',
                inputs: [
                        {id: 'course_checked', value: '1'},
                        {id: 'budget_within_criteria', value: '1'},
                ],
                validator: {
                    type: 'checkbox',
                    required: false,
                },
                error: { status: null, msg: '' },
            },
            input_eec_hdc: {
                display: 'inline',
                label: '',
                inputs: [
                        {id: 'course_checked', value: '1'},
                        {id: 'budget_within_criteria', value: '1'},
                ],
                validator: {
                    type: 'checkbox',
                    required: false,
                },
                error: { status: null, msg: '' },
            }            
        }        
    },
    Approved: false,
}           